import $ from 'jquery';

const breakpoint = 1200;

class Viewport {
  constructor(_breakpoint) {
    this.breakpoint = _breakpoint || breakpoint;
    this.change = this.change.bind(this);
    this.ticking = false;
    this.addListeners();
  }

  // state {Boolean}
  setCurrentState(state) {
    this.mobileState = state;
  }

  getCurrentState() {
    return window.innerWidth < this.breakpoint;
  }

  update() {
    this.ticking = false;
    const currentState = this.getCurrentState();
    const previousState = this.mobileState;

    // Announce screen has changed
    if (this.changeCallbacks) {
      this.changeCallbacks.fire();
    }

    // Check to see if the view state has changed
    if (currentState !== previousState) {
      this.setCurrentState(currentState);

      // Announce screen has changed to mobile mode
      if (this.mobileCallbacks && this.mobileState) {
        this.mobileCallbacks.fire();
      }

      // Announce screen has changed to desktop mode
      if (this.desktopCallbacks && !this.mobileState) {
        this.desktopCallbacks.fire();
      }
    }
  }

  change() {
    this.requestTick();
  }

  requestTick() {
    if (!this.ticking) {
      requestAnimationFrame(this.update.bind(this));
      this.ticking = true;
    }
  }

  onMobileChange(callback) {
    if (!this.mobileCallbacks) {
      this.mobileCallbacks = $.Callbacks('memory');
    }
    this.mobileCallbacks.add(callback);
    return this;
  }

  onDesktopChange(callback) {
    if (!this.desktopCallbacks) {
      this.desktopCallbacks = $.Callbacks('memory');
    }
    this.desktopCallbacks.add(callback);
    return this;
  }

  onChange(callback) {
    if (!this.changeCallbacks) {
      this.changeCallbacks = $.Callbacks('memory');
    }
    this.changeCallbacks.add(callback);
    return this;
  }

  addListeners() {
    $(window).on('resize orientationchange', this.change);
  }
}

// Default viewport with default breakpoint setting.
export const viewport = new Viewport();

// Export both the default and the class to reuse with alternate breakpoints.
export default Viewport;
